<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex s-bt" >
      <comboFarm @fromFarm="farmInfo" />
      <img :src="icon_raw" class="raw_icon" @click="RawRouter(farmData)"/>
    </div>

    <v-tabs 
      v-model="activeTab" 
      color="#005B96"
      class="weather-tab"
    >
      <v-tab v-for="(device, index) in mergedList" :key="index" class="custom-tab">
       {{ device.eqmnname }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" class="mt-4 tab-content">
      <div class="spinner mb-10 mt-5" v-if="loading"></div>

      <v-tab-item v-for="(device, index) in mergedList" :key="index" v-else>

        <div class="flex-center">
          <div class="total_water">
            <div class="box_title">농장 24시간 누적 음수량</div>
            <div class="box_info">{{ farmTotalSum.timeTotal }}
              <span class="box_title">L</span>
            </div>
          </div>

          <div class="total_water ml-5">
            <div class="box_title">농장 한달 누적 음수량</div>
            <div class="box_info">{{ farmTotalSum.dailyTotal }}
              <span class="box_title">L</span>
            </div>
          </div>
        </div>

        <div class="chart_layout mb-2 mt-5">
          <div class="box_title bold-weight mb-2 flex s-bt">
            <div class="flex">
              24시간 음수량 추이 : {{ totalSum(device.timeData) }} L
              <button class="reset_btn ml-2" @click="resetTime('time')">
                <v-icon size="20" color="white">mdi-redo-variant mdi-rotate-180</v-icon>
              </button>
            </div>

            <div>
              {{ timelyDate }} 기준
            </div>
          </div>
          
          <div class="chart-container">
            <button class="prev-btn" >
              <v-icon color="#005B96" @click="prevTime()">mdi-chevron-left</v-icon>
            </button> 

            <div class="chart">
              <Chart 
                chartType="Bar"
                :chartData="getChartData(device.timeData, 'time')"
                :chartOptions="barChartOptions"
                :chartSize="chartSize"
              />
            </div>

            <button class="next-btn" >
              <v-icon color="#005B96" @click="nextTime()" v-if="timelyDate !== today">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>

        <div class="chart_layout">
          <div class="box_title bold-weight mb-2 flex s-bt">
            <div class="flex">
              30일 음수량 추이 :  {{ totalSum(device.dailyData) }} L
              <button class="reset_btn ml-2" @click="resetTime('day')">
                <v-icon size="20" color="white">mdi-redo-variant mdi-rotate-180</v-icon>
              </button>
            </div>
          
            <div>
              {{ dailyDate }} 기준
            </div>
          </div>
          
          <div class="chart-container">
            <button class="prev-btn" >
              <v-icon color="#005B96" @click="prevDay()">mdi-chevron-left</v-icon>
            </button> 

            <div class="chart">
              <Chart 
              chartType="Bar"
              :chartData="getChartData(device.dailyData, 'day')"
              :chartOptions="barChartOptions"
              :chartSize="chartSize"
            />
            </div>

            <button class="next-btn" >
              <v-icon color="#005B96" @click="nextDay()" v-if="dailyDate !== today">mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
 
      </v-tab-item>
    </v-tabs-items>
   
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import Chart from "@/components/chart/Chart.vue"
import { barChartOptions} from "@/components/chart/option.js";  // 옵션 불러오기

export default {
  name: 'Autowater',
  components:{
    comboFarm,
    Chart,
  },
  
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

  },
  // 일별, 시간별 합치기
    computed: {
      mergedList() {
      // eqpmnno 기준으로 장비 리스트를 병합 처리 (timely와 daily 모두 체크)
      const eqpmnMap = new Map();

      // 먼저 daily_water로 초기화
      this.daily_water.forEach(d => {
        eqpmnMap.set(d.eqpmnno, {
          eqpmnno: d.eqpmnno,
          eqmnname: d.eqmnname || '',
          timeData: [],
          dailyData: d.values || []
        });
      });

      // timely_water 덮어쓰기 또는 추가
      this.timely_water.forEach(t => {
        if (eqpmnMap.has(t.eqpmnno)) {
          eqpmnMap.get(t.eqpmnno).timeData = t.values || [];
          eqpmnMap.get(t.eqpmnno).eqmnname = t.eqmnname || eqpmnMap.get(t.eqpmnno).eqmnname;
        } else {
          eqpmnMap.set(t.eqpmnno, {
            eqpmnno: t.eqpmnno,
            eqmnname: t.eqmnname || '',
            timeData: t.values || [],
            dailyData: []
          });
        }
      });

      return Array.from(eqpmnMap.values());
    },
    currentDevice() {
      return this.mergedList[this.activeTab];
    },
    // 농장 전체 함산
    farmTotalSum() {
      // 데이터가 없으면 0 리턴
      if (!this.mergedList || this.mergedList.length === 0) {
        return { timeTotal: 0, dailyTotal: 0 };
      }

      let timeSum = 0;
      let dailySum = 0;

      this.mergedList.forEach(device => {
        if (device.timeData) {
          timeSum += device.timeData.reduce((acc, cur) => acc + (Number(cur.value) || 0), 0);
        }

        if (device.dailyData) {
          dailySum += device.dailyData.reduce((acc, cur) => acc + (Number(cur.value) || 0), 0);
        }
      });

      return {
        timeTotal: timeSum.toFixed(1),
        dailyTotal: dailySum.toFixed(1)
      };
    }
  },
  data(){
    let today = dateUtil.format(new Date(), "yyyy-MM-dd");
    
    return {
      farmData: { company: {}, farm: {} },
      icon_raw: require("@/assets/pack/raw_data.svg"),
     
      activeTab: 0,
      timely_water: [],
      daily_water: [],

      barChartOptions:barChartOptions,

      chartSize: {
        height:'200px',
        width: '100%',
      },

      chartTimely: {
        labels: [],
        datasets: []
      },
      chartDaily: {
        labels: [],
        datasets: []
      },

      today: today,           // 리셋용 오늘 날짜 저장
      timelyDate: today,      // 24시간 차트용 날짜
      dailyDate: today,       // 일별 차트용 날짜

      loading:false,
    }
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;

      this.refresh();
    },
    RawRouter(farmData){
      // console.log(farmData)
      // this.$router.push({
      //   name: "rawData",
      //   params: { 
      //     farm:{code: farmData.farm.code, name: farmData.farm.name},
      //     typeCode: "AF02"
      //     // tyspe:{code:'AF02', name:'음수관리기'}
      //    }
      // });
      sessionStorage.setItem("pack_farm", JSON.stringify({
        farm: { code: farmData.farm.code, name: farmData.farm.name }
      }));

      this.$router.push({
        name: "rawData",
        params: { 
          typeCode: "AF02" 
        }
      });
    },
    refresh(){
      this.timely_water = []; 
      this.daily_water = [];
      this.activeTab = 0;   
      
      // 새로고침하면 둘 다 오늘로 초기화
      this.timelyDate = this.today;
      this.dailyDate = this.today;

      this.statisticsOfDiaryWaterTimely();
      this.statisticsOfDairyWaterDaily();

      this.loading=true;
    },
    resetTime(type){
      if (type === 'time') {
        this.timelyDate = this.today;         // 24시간 날짜만 오늘로
        this.statisticsOfDiaryWaterTimely(); 
      } else {
        this.dailyDate = this.today;          // 일별 날짜만 오늘로
        this.statisticsOfDairyWaterDaily();  
      }
    },
    // 시간 하루전
    prevTime() {
      let cdate = new Date(this.timelyDate);
      cdate.setDate(cdate.getDate() - 1);

      this.timelyDate = dateUtil.format(cdate, "yyyy-MM-dd");

      this.statisticsOfDiaryWaterTimely();
    },
    // 시간 하루 +
    nextTime() {
      let cdate = new Date(this.timelyDate);

      cdate.setDate(cdate.getDate() + 1);
      
      let nextDateStr = dateUtil.format(cdate, "yyyy-MM-dd");

      if (nextDateStr > this.today) {
        nextDateStr = this.today;
      }

      this.timelyDate = nextDateStr;

      this.statisticsOfDiaryWaterTimely();
    },
    // 30일 전
    prevDay() {
      let cdate = new Date(this.dailyDate);
      
      cdate.setDate(cdate.getDate() - 30);

      this.dailyDate = dateUtil.format(cdate, "yyyy-MM-dd");
      this.statisticsOfDairyWaterDaily();
    },

    // 30일 후
    nextDay() {
      let cdate = new Date(this.dailyDate);
      
      // 30일 더합니다
      cdate.setDate(cdate.getDate() + 30);
      
      let nextDateStr = dateUtil.format(cdate, "yyyy-MM-dd");

      if (nextDateStr > this.today) {
        nextDateStr = this.today;
      }

      this.dailyDate = nextDateStr;
      this.statisticsOfDairyWaterDaily();
    },
    statisticsOfDiaryWaterTimely(){
      Apis.statisticsOfDiaryWaterTimely({
        "farm_cd" : this.farmData.farm.code,
        "stand_date" : this.timelyDate,
        "number" : 24
      }, (res) => {
        if (res.result) { 
          // console.log(res)
          this.timely_water = res.data;
          this.loading=false;

        } else {
          alert(res.message);
        }
      }).catch((err) => {
        console.error("statisticsOfDiaryWaterTimely 오류", err);
      });
    },
    statisticsOfDairyWaterDaily(){
      Apis.statisticsOfDairyWaterDaily({
        "farm_cd" : this.farmData.farm.code,
        "stand_date" : this.dailyDate,
        "number" : 31
      }, (res) => {
        if (res.result) { 
          // console.log(res)
          
          this.daily_water = res.data;
          this.loading=false;


        } else {
          alert(res.message);
        }
      }).catch((err) => {
        console.error("statisticsOfDairyWaterDaily 오류", err);
      });
    },
    totalSum(data) {
      if (!data || data.length === 0) return 0;
      
      const sum = data.reduce((acc, cur) => {
        return acc + (Number(cur.value) || 0);
      }, 0);

      return sum.toFixed(1); 
    },
    getChartData(dataList, type) {
      if (!dataList) return { labels: [], datasets: [] };

        let labels = [];
        let values = [];

        dataList.forEach(item => {
          let dateLabel = item.date;
          let date = new Date(item.date);
          
          if (!isNaN(date)) {
            if (type === 'time') {
              // 시간별: "16시" 형태로 변환
              dateLabel = date.getHours() + '시';
            } else {
              // 일별: "27일" 형태로 변환
              dateLabel = date.getDate() + '일';
            }
          }
          
          labels.push(dateLabel);
          values.push(item.value);
        });

        return {
          labels: labels,
          datasets: [
            {
              label: '음수량', 
              data: values,
              backgroundColor: 'rgba(0, 91, 150, 0.6)', 
              borderColor: 'rgba(0, 91, 150, 1)',
              borderWidth: 0,
              barPercentage: 0.99, 
            }
          ]
        };
      }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.weather-tab{
  width:450px;
}
.custom-tab{
 width:10vw !important;
 font-weight:$bold-weight;
 letter-spacing: -0.75px;
 font-size:0.9rem;
}
.tab-content{
  min-width:100%;
  background-color: transparent;
  // border: 1px solid #D5D5D5;
  padding:20px;
}
.total_water{
  box-sizing: border-box;
  padding:10px;
  background: #FFFFFF;
  border-left: 7px solid $main-color;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width:180px;
  height:80px;
}
.box_title{
  color:#6E6E6E;
  font-size:0.95rem;
  font-weight:600;
  letter-spacing: -0.75px;
}
.box_info{
  color:$main-color;
  font-weight:550;
  font-size:1.7rem;
  // margin-top:3px;
}

.chart-container {
  margin-top:-10px;
  display: flex;
  align-items: center;
}
.chart_layout {
  width: 100%;
  max-height: 400px; 
  overflow: hidden;
}
.chart{
  width: 95%;
  max-height: 400px; 
}
.reset_btn{
  border-radius: 50%;
  background-color: $main-color !important;
  width:25px !important;
  height:25px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.prev-btn, .next-btn {
  padding: 1px;
  background-color: #daeaff;
  border-radius: 25px;
  z-index:2;
  cursor: pointer;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.prev-btn{
  margin-right:10px;
}
.next-btn{
  margin-left:10px;
}
@media only screen and (max-width: 768px){
  .chart_layout{
    width:100% !important; 
  }
  .chart{
    margin-left:-10px;
  }
  .tab-content{
    margin-left:-10px;
  }
}
</style>